export default "__VITE_ASSET__BQg8Ofwk__"